/* Hair Health System quiz engine.
   Data sources (kept separate on purpose — see HAIR-SYSTEM-QUIZ-SPEC.md §5):
     1. hair-quiz-config.json (static asset, fetched below) — pillars, sku->pillar
        mapping, tier composition per branch, question copy. Editable without
        touching this file or the Liquid template — adding a 3rd tier later is
        a data change here, not a quiz rebuild.
     2. #hair-quiz-product-data (inline JSON, rendered by Liquid in
        seed-quiz-ported.liquid) — real Shopify variant IDs, selling plan IDs,
        and live prices, resolved the same way seedx-selling-plan-input.liquid
        resolves them on every PDP today.
   No per-product pillar "score" exists anywhere real (see spec §0/§7.1) — this
   engine only ever computes binary pillar coverage + a depth count, never a
   fabricated composite number. */
(function () {
  "use strict";

  var root = document.getElementById("hair-quiz-app");
  if (!root) return;

  var configUrl = root.getAttribute("data-config-url");
  var productDataEl = document.getElementById("hair-quiz-product-data");
  var productData = productDataEl ? JSON.parse(productDataEl.textContent) : {};

  var state = {
    answers: {},
    history: ["sex"],
    config: null
  };

  function esc(str) {
    var d = document.createElement("div");
    d.textContent = str == null ? "" : String(str);
    return d.innerHTML;
  }

  function money(n) {
    var v = parseFloat(n || 0);
    return "$" + v.toFixed(2).replace(/\.00$/, "");
  }

  // ---- sequence -----------------------------------------------------------

  function buildSequence(answers) {
    var seq = ["sex", "concern", "reveal1", "duration", "age", "priorTreatments"];
    if (answers.sex === "women") seq.push("pregnancy");
    seq.push("allergies", "reveal2", "commitment", "email");
    return seq;
  }

  function currentIndex() {
    return state.history.length - 1;
  }

  function currentScreenId() {
    return state.history[state.history.length - 1];
  }

  function goNext() {
    var seq = buildSequence(state.answers);
    var idx = seq.indexOf(currentScreenId());
    var next = seq[idx + 1];
    if (!next) {
      showResults();
      return;
    }
    state.history.push(next);
    render();
  }

  function goBack() {
    if (state.history.length <= 1) return;
    state.history.pop();
    render();
  }

  function totalSteps() {
    return buildSequence(state.answers).length;
  }

  // ---- boot -----------------------------------------------------------

  fetch(configUrl)
    .then(function (r) { return r.json(); })
    .then(function (cfg) {
      state.config = cfg;
      render();
    })
    .catch(function (err) {
      root.innerHTML = '<div class="hq-stage"><p>The quiz couldn\'t load right now — please refresh.</p></div>';
      console.error("hair-quiz: config load failed", err);
    });

  function findQuestion(id) {
    return state.config.questions.filter(function (q) { return q.id === id; })[0];
  }

  // ---- render dispatch -----------------------------------------------------------

  function render() {
    var screen = currentScreenId();
    var seq = buildSequence(state.answers);
    var idx = seq.indexOf(screen);
    var progressPct = Math.round(((idx) / (seq.length)) * 100);

    var body;
    if (screen === "reveal1") body = renderReveal1();
    else if (screen === "reveal2") body = renderReveal2();
    else body = renderQuestion(findQuestion(screen));

    root.innerHTML =
      '<div class="hq-app">' +
      '<div class="hq-topbar">' +
      '<a class="hq-topbar__logo" href="' + root.getAttribute("data-home-url") + '">' + esc(root.getAttribute("data-brand-name")) + "</a>" +
      '<div class="hq-progress"><div class="hq-progress__bar" style="width:' + progressPct + '%"></div></div>' +
      '<a class="hq-topbar__exit" href="' + root.getAttribute("data-shop-url") + '">Exit</a>' +
      "</div>" +
      '<div class="hq-stage"><div class="hq-panel">' + body + "</div></div>" +
      "</div>";

    wireEvents(screen);
  }

  // ---- question rendering -----------------------------------------------------------

  function renderQuestion(q) {
    var backBtn = state.history.length > 1 ? '<button type="button" class="hq-btn hq-btn--secondary" data-action="back">Back</button>' : "<span></span>";
    var html = '<h1 class="hq-title">' + esc(q.title) + "</h1>" +
      (q.subtitle ? '<p class="hq-subtitle">' + esc(q.subtitle) + "</p>" : "");

    if (q.type === "single") {
      html += '<div class="hq-options" data-select-mode="single" data-qid="' + q.id + '">';
      q.options.forEach(function (opt) {
        var selected = state.answers[q.id] === opt.value;
        html += '<button type="button" class="hq-option' + (selected ? " is-selected" : "") + '" data-value="' + esc(opt.value) + '"><span class="hq-option__mark"></span>' + esc(opt.label) + "</button>";
      });
      html += "</div>";
      html += '<div class="hq-nav">' + backBtn + "<span></span></div>";
    } else if (q.type === "multi") {
      var selArr = state.answers[q.id] || [];
      html += '<div class="hq-options" data-select-mode="multi" data-qid="' + q.id + '">';
      q.options.forEach(function (opt) {
        var selected = selArr.indexOf(opt.value) !== -1;
        html += '<button type="button" class="hq-option' + (selected ? " is-selected" : "") + '" data-value="' + esc(opt.value) + '"><span class="hq-option__mark"></span>' + esc(opt.label) + "</button>";
      });
      html += "</div>";
      html += '<div class="hq-nav">' + backBtn + '<button type="button" class="hq-btn hq-btn--primary" data-action="next" ' + (selArr.length ? "" : "disabled") + ">Next</button></div>";
    } else if (q.type === "text") {
      var val = state.answers[q.id] || "";
      html += '<input type="text" class="hq-text-input" data-qid="' + q.id + '" placeholder="' + esc(q.placeholder || "") + '" value="' + esc(val) + '">';
      html += '<div class="hq-nav">' + backBtn + '<button type="button" class="hq-btn hq-btn--primary" data-action="next">' + (val ? "Next" : "Skip") + "</button></div>";
    } else if (q.type === "email") {
      var evalv = state.answers[q.id] || "";
      html += '<input type="email" class="hq-email-input" data-qid="' + q.id + '" placeholder="' + esc(q.placeholder || "") + '" value="' + esc(evalv) + '" autocomplete="email">';
      html += '<div class="hq-nav">' + backBtn + '<button type="button" class="hq-btn hq-btn--primary" data-action="submit-email" disabled>' + esc(q.submitLabel || "Show My Results") + "</button></div>";
    }
    return html;
  }

  function pillarsForConcerns(concernValues) {
    var set = {};
    var order = [];
    (concernValues || []).forEach(function (c) {
      var pillars = state.config.concernPillarMap[c] || [];
      pillars.forEach(function (p) {
        if (!set[p]) { set[p] = true; order.push(p); }
      });
    });
    return order;
  }

  function pillarLabel(id) {
    var p = state.config.pillars.filter(function (x) { return x.id === id; })[0];
    return p ? p.label : id;
  }

  function renderReveal1() {
    var concerns = state.answers.concern || [];
    var pillars = pillarsForConcerns(concerns);
    var html = '<div class="hq-reveal">' +
      '<div class="hq-reveal__eyebrow">Here’s what’s likely driving this</div>' +
      '<div class="hq-reveal__pillars">';
    state.config.pillars.forEach(function (p) {
      var lit = pillars.indexOf(p.id) !== -1;
      html += '<div class="hq-reveal-pillar' + (lit ? " is-lit" : "") + '"><div class="hq-reveal-pillar__dot"></div><div class="hq-reveal-pillar__label">' + esc(p.label) + "</div></div>";
    });
    html += "</div>";
    html += '<p class="hq-reveal__quote">“' + esc(state.config.wesleyQuotes.targeting) + '” <span style="opacity:.7">— Dr. Carlos Wesley</span></p>';
    html += '<button type="button" class="hq-btn hq-btn--primary" data-action="next">Continue</button>';
    html += "</div>";
    return html;
  }

  function renderReveal2() {
    var concerns = state.answers.concern || [];
    var pillars = pillarsForConcerns(concerns);
    var count = pillars.length;
    var html = '<div class="hq-reveal">' +
      '<div class="hq-reveal__eyebrow">Your Pillar Map so far</div>' +
      '<div class="hq-reveal__count">' + count + " of 4 identified</div>" +
      '<div class="hq-reveal__pillars">';
    state.config.pillars.forEach(function (p) {
      var lit = pillars.indexOf(p.id) !== -1;
      html += '<div class="hq-reveal-pillar' + (lit ? " is-lit" : "") + '"><div class="hq-reveal-pillar__dot"></div><div class="hq-reveal-pillar__label">' + esc(p.label) + "</div></div>";
    });
    html += "</div>";
    html += '<p class="hq-reveal__quote">Your full protocol — built from every answer, not just this one — is next.</p>';
    html += '<button type="button" class="hq-btn hq-btn--primary" data-action="next">Continue</button>';
    html += "</div>";
    return html;
  }

  // ---- event wiring -----------------------------------------------------------

  function wireEvents(screen) {
    root.querySelectorAll('[data-action="back"]').forEach(function (b) {
      b.addEventListener("click", goBack);
    });
    root.querySelectorAll('[data-action="next"]').forEach(function (b) {
      b.addEventListener("click", goNext);
    });

    var opts = root.querySelector(".hq-options");
    if (opts) {
      var mode = opts.getAttribute("data-select-mode");
      var qid = opts.getAttribute("data-qid");
      opts.querySelectorAll(".hq-option").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var val = btn.getAttribute("data-value");
          if (mode === "single") {
            state.answers[qid] = val;
            goNext();
          } else {
            var arr = state.answers[qid] || [];
            var i = arr.indexOf(val);
            if (i === -1) arr.push(val); else arr.splice(i, 1);
            state.answers[qid] = arr;
            render();
          }
        });
      });
    }

    var textInput = root.querySelector(".hq-text-input");
    if (textInput) {
      var tqid = textInput.getAttribute("data-qid");
      textInput.addEventListener("input", function () {
        state.answers[tqid] = textInput.value;
        var nextBtn = root.querySelector('[data-action="next"]');
        if (nextBtn) nextBtn.textContent = textInput.value ? "Next" : "Skip";
      });
    }

    var emailInput = root.querySelector(".hq-email-input");
    if (emailInput) {
      var eqid = emailInput.getAttribute("data-qid");
      var submitBtn = root.querySelector('[data-action="submit-email"]');
      var validate = function () {
        var v = emailInput.value.trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        state.answers[eqid] = v;
        if (submitBtn) submitBtn.disabled = !ok;
        return ok;
      };
      emailInput.addEventListener("input", validate);
      validate();
      if (submitBtn) {
        submitBtn.addEventListener("click", function () {
          if (!validate()) return;
          submitBtn.disabled = true;
          submitBtn.textContent = "Loading…";
          finishAndShowResults();
        });
      }
    }
  }

  // ---- final submit (best-effort real leads, never blocks results) -----------------------------------------------------------
  // Shopify's /contact endpoint rejects fetch()/XHR posts (confirmed: returns 400 for a
  // script-initiated POST, but 200s the identical fields via a real form navigation --
  // same fields, same endpoint, only the request type differs). So these submit through a
  // real hidden <form target="iframe"> navigation, same mechanism as every native Shopify
  // form on this theme (see seed-shell-footer.liquid's newsletter form), just targeted at
  // an invisible iframe instead of the visible page so the quiz doesn't reload.

  function getHiddenSubmitTarget() {
    var iframe = document.getElementById("hq-hidden-target");
    if (!iframe) {
      iframe = document.createElement("iframe");
      iframe.name = "hq-hidden-target";
      iframe.id = "hq-hidden-target";
      iframe.style.display = "none";
      document.body.appendChild(iframe);
    }
    return iframe;
  }

  function submitViaHiddenForm(fields) {
    var iframe = getHiddenSubmitTarget();
    var form = document.createElement("form");
    form.method = "POST";
    form.action = "/contact";
    form.target = iframe.name;
    form.style.display = "none";
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    setTimeout(function () { form.remove(); }, 4000);
  }

  function finishAndShowResults() {
    var email = state.answers.email;
    var results = computeResults(state.answers, state.config, productData);
    var tierSummary = results.tiers.map(function (t) { return t.label + ": " + t.skuList.join("+"); }).join(" / ");

    submitEmailLead(email);
    if (state.answers.allergies) submitAllergyFlag(email, state.answers.allergies, tierSummary);

    showResults();
  }

  function submitEmailLead(email) {
    submitViaHiddenForm({
      form_type: "customer",
      utf8: "✓",
      "contact[email]": email,
      "contact[tags]": "quiz-lead"
    });
  }

  function submitAllergyFlag(email, note, tierSummary) {
    submitViaHiddenForm({
      form_type: "contact",
      utf8: "✓",
      "contact[name]": "Hair Health System Quiz",
      "contact[email]": email,
      "contact[body]": "Hair Health System quiz — allergy/kosher flag: " + note + "\n\nQuiz recommendation: " + tierSummary + "\n\nThis was asked but is not yet auto-filtered against real per-SKU allergen data — please review manually."
    });
  }

  // ---- results computation -----------------------------------------------------------

  function computeResults(answers, config, productData) {
    var sexKey = answers.sex;
    var pregnancyExcluded = sexKey === "women" && answers.pregnancy === "yes";
    var tierBranch = sexKey === "men" ? "men" : (pregnancyExcluded ? "women_excluded" : "women");
    var tierDefs = config.tiers[tierBranch];
    var highlightedKey = answers.commitment === "allin" ? "plus" : "basic";

    var concernPillars = pillarsForConcerns(answers.concern);
    var priorityPillar = null;
    (answers.concern || []).forEach(function (c) {
      if (config.nutritionPriorityConcerns.indexOf(c) !== -1) priorityPillar = "nutritional";
    });

    var tiers = ["basic", "plus"].map(function (key) {
      return buildTierCard(key, tierDefs[key], config, productData, key === highlightedKey, priorityPillar);
    });

    return { pregnancyExcluded: pregnancyExcluded, tierBranch: tierBranch, tiers: tiers, priorityPillar: priorityPillar, concernPillars: concernPillars };
  }

  function buildTierCard(key, def, config, productData, isRecommended, priorityPillar) {
    var pillarDepth = {};
    var skuRows = def.skus.map(function (sku) {
      var skuDef = config.skus[sku] || { pillars: [] };
      skuDef.pillars.forEach(function (p) { pillarDepth[p] = (pillarDepth[p] || 0) + 1; });
      var pd = productData[sku] || {};
      return {
        sku: sku,
        title: pd.title || sku,
        url: pd.url || "#",
        pillars: skuDef.pillars,
        consultRequired: !!skuDef.consultRequired,
        variantId: pd.variantId,
        sellingPlanId: pd.sellingPlanId || null,
        price: pd.price,
        subPrice: pd.subPrice
      };
    });

    var consultRows = skuRows.filter(function (r) { return r.consultRequired; });
    var otcRows = skuRows.filter(function (r) { return !r.consultRequired; });

    var otcSubtotal = otcRows.reduce(function (s, r) { return s + parseFloat(r.subPrice || r.price || 0); }, 0);
    var consultSubtotal = consultRows.reduce(function (s, r) { return s + parseFloat(r.subPrice || r.price || 0); }, 0);

    var pillarCoverage = config.pillars.map(function (p) {
      return { id: p.id, label: p.label, blurb: p.blurb, covered: !!pillarDepth[p.id], depth: pillarDepth[p.id] || 0 };
    });
    var coveredCount = pillarCoverage.filter(function (p) { return p.covered; }).length;

    return {
      key: key,
      label: def.label,
      description: def.description || "",
      skuList: def.skus,
      skuRows: skuRows,
      otcRows: otcRows,
      consultRows: consultRows,
      otcSubtotal: otcSubtotal,
      consultSubtotal: consultSubtotal,
      total: otcSubtotal + consultSubtotal,
      pillarCoverage: pillarCoverage,
      coveredCount: coveredCount,
      isRecommended: isRecommended,
      priorityPillar: priorityPillar
    };
  }

  // ---- results rendering -----------------------------------------------------------

  function showResults() {
    var results = computeResults(state.answers, state.config, productData);
    var html = '<div class="hq-app"><div class="hq-stage" style="align-items:flex-start;padding-top:2rem"><div class="hq-results">';

    html += '<div class="hq-results__header">' +
      '<h1 class="hq-results__title">Your Hair Health System</h1>' +
      '<p class="hq-results__subtitle">Built from your answers — 4 real pillars, honestly covered.</p>' +
      "</div>";

    var refTier = results.tiers[0];
    html += '<div class="hq-pillarmap">';
    refTier.pillarCoverage.forEach(function (p) {
      html += '<div class="hq-pillarmap-item' + (p.covered ? "" : " is-dim") + '"><div class="hq-pillarmap-item__icon">' + (p.covered ? "✓" : "—") + "</div><div class=\"hq-pillarmap-item__label\">" + esc(p.label) + '</div><div class="hq-pillarmap-item__blurb">' + esc(p.blurb) + "</div></div>";
    });
    html += "</div>";
    html += '<p class="hq-pairing-quote">“' + esc(state.config.wesleyQuotes.pairing) + '” — Dr. Carlos Wesley</p>';

    if (results.pregnancyExcluded) {
      html += '<div class="hq-exclusion-note">Because you told us you’re currently pregnant or breastfeeding, we’ve removed WB01 from your recommendation — that’s a real precaution on its label, not a formality. Your system below covers 2 of 4 pillars honestly rather than padding the count.</div>';
    }

    if (state.answers.allergies) {
      html += '<p class="hq-flag-note">Noted — we’ve flagged “' + esc(state.answers.allergies) + '” for our care team ahead of your first order. We don’t yet auto-filter products against this, so a real person will review it.</p>';
    }

    html += '<div class="hq-tiers">';
    results.tiers.forEach(function (t) { html += renderTierCard(t); });
    html += "</div>";

    html += '<div class="hq-restart"><a href="" data-action="restart">Retake the quiz</a></div>';
    html += "</div></div></div>";

    root.innerHTML = html;

    root.querySelectorAll('[data-action="add-otc"]').forEach(function (btn) {
      btn.addEventListener("click", function () { addTierOtcToCart(btn); });
    });
    var restart = root.querySelector('[data-action="restart"]');
    if (restart) restart.addEventListener("click", function (e) { e.preventDefault(); window.location.reload(); });
  }

  function renderTierCard(t) {
    var html = '<div class="hq-tier-card' + (t.isRecommended ? " is-recommended" : "") + '">';
    if (t.isRecommended) html += '<span class="hq-tier-card__badge">Matched to your answers</span>';
    html += '<h2 class="hq-tier-card__name">' + esc(t.label) + "</h2>";
    html += '<p class="hq-tier-card__desc">' + t.coveredCount + " of 4 pillars covered — " + esc(t.description) + "</p>";

    html += '<ul class="hq-tier-card__skus">';
    t.skuRows.forEach(function (r) {
      html += '<li class="hq-tier-sku"><span class="hq-tier-sku__name">' + esc(r.title) + (r.consultRequired ? " (consult required)" : "") + '</span><span class="hq-tier-sku__pillars">' + r.pillars.map(pillarLabel).join(" + ") + "</span></li>";
    });
    html += "</ul>";

    if (t.priorityPillar === "nutritional" && t.key === "plus") {
      html += '<p class="hq-tier-card__price-note">Extra Nutrition depth added based on your answers.</p>';
    }

    html += '<p class="hq-tier-card__price">' + money(t.total) + "/mo</p>";
    html += '<p class="hq-tier-card__price-note">Subscribe &amp; Save, cancel anytime' + (t.consultRows.length ? " on the OTC portion" : "") + ".</p>";

    html += '<div class="hq-tier-card__cta-group">';
    if (t.otcRows.length) {
      html += '<button type="button" class="hq-btn hq-btn--primary hq-btn--full" data-action="add-otc" data-tier="' + t.key + '">Add ' + t.otcRows.length + " item" + (t.otcRows.length > 1 ? "s" : "") + " to Cart — " + money(t.otcSubtotal) + "/mo</button>";
    }
    if (t.consultRows.length) {
      t.consultRows.forEach(function (r) {
        html += '<div class="hq-consult-note"><p class="hq-consult-note__title">' + esc(r.title) + " requires a quick consult first</p>" +
          "<p>This is Rx-adjacent — it can’t be added to cart like an OTC item. Request a consult and our team will follow up.</p>" +
          '<a class="hq-btn hq-btn--primary" href="' + r.url + '#wb01-consult-form" target="_blank" rel="noopener">Request a Consult →</a></div>';
      });
    }
    html += '<div class="hq-cart-status" data-cart-status data-tier="' + t.key + '"></div>';
    html += "</div>";
    html += "</div>";
    return html;
  }

  function addTierOtcToCart(btn) {
    var tierKey = btn.getAttribute("data-tier");
    var results = computeResults(state.answers, state.config, productData);
    var tier = results.tiers.filter(function (t) { return t.key === tierKey; })[0];
    var statusEl = root.querySelector('[data-cart-status][data-tier="' + tierKey + '"]');

    var items = tier.otcRows.map(function (r) {
      var item = { id: r.variantId, quantity: 1 };
      if (r.sellingPlanId) item.selling_plan = r.sellingPlanId;
      return item;
    });

    btn.disabled = true;
    btn.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || "Cart add failed"); });
        return res.json();
      })
      .then(function () {
        btn.textContent = "Added to Cart ✓";
        if (statusEl) statusEl.textContent = "Redirecting to your cart…";
        setTimeout(function () { window.location.href = "/cart"; }, 900);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = "Try Again";
        if (statusEl) { statusEl.textContent = "Couldn’t add to cart: " + err.message; statusEl.classList.add("is-error"); }
        console.error("hair-quiz: cart add failed", err);
      });
  }
})();
